export default __webpack_public_path__ + "static/media/watt&Volt_ΦΑ.744096b9.png";